// https://github.com/ReactiveX/rxjs/issues/2823

import { defer, MonoTypeOperatorFunction, never, Observable, of, throwError } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

export enum DisposeReason {
  Unsubscribe = 'unsubscribe',
  Complete = 'complete',
  Error = 'error',
}

type CallbackFunc = (reason: DisposeReason) => void;

// tslint:disable-next-line:typedef
export const finalizeWithReason = <T>(callback: CallbackFunc): MonoTypeOperatorFunction<T> =>
  (source: Observable<T>) =>
    defer(() => {
      // tslint:disable-next-line:typedef
      let completed = false;
      // tslint:disable-next-line:typedef
      let errored = false;

      return source.pipe(
        tap({
          error: () => errored = true,
          complete: () => completed = true,
        }),
        finalize(() => {
          if (errored) {
            callback(DisposeReason.Error);
          } else if (completed) {
            callback(DisposeReason.Complete);
          } else {
            callback(DisposeReason.Unsubscribe);
          }
        }),
      );
    });

// tslint:disable-next-line:typedef
const finalizeCallback = (reason: DisposeReason) => console.log(reason);
// tslint:disable-next-line:typedef
const observer = {
  next: () => {
  },
  error: () => {
  },
  complete: () => {
  },
};

throwError(new Error()).pipe(
  finalizeWithReason(finalizeCallback),
).subscribe(observer);

of().pipe(
  finalizeWithReason(finalizeCallback),
).subscribe(observer);

never().pipe(
  finalizeWithReason(finalizeCallback),
).subscribe(observer).unsubscribe();

const s = of().pipe(
  finalizeWithReason(finalizeCallback),
)
